import React from 'react';
import autobind from 'autobind';
import { observer, inject } from 'mobx-react';
import { withRouter, WithRouterProps } from '@hoc/withRouterProps';

import { ConfirmPopup } from '@components/Popup/ConfirmPopup';
import { authUserService } from '@store/AuthUser/services/authUserService';
import { AppState } from '@store/App/App';
import { translate } from '@chaika/i18n/helper';

interface StoreProps {
    app: AppState;
}

@(withRouter as any)
@observer
class Component extends React.Component<StoreProps & WithRouterProps> {
    public render(): React.ReactNode {
        return React.createElement(ConfirmPopup, {
            title: translate('accessDenied'),
            description: translate('sessionMayExpired'),
            confirmText: translate('login'),
            cancelText: translate('toMainPage'),
            onConfirm: this.handleAuthorizeClick,
            onCancel: this.handleRedirectToMainPageClick,
        });
    }

    @autobind
    private async handleAuthorizeClick(): Promise<void> {
        const { app } = this.props;

        app.forbiddenResources = false;

        // The session may already be restored in another tab: logging out would end it for every tab again
        if (await this.isSessionAlive()) {
            window.location.reload();
            return;
        }

        await authUserService.logout();
    }

    @autobind
    private async handleRedirectToMainPageClick(): Promise<void> {
        const { app, navigate } = this.props;

        app.forbiddenResources = false;
        navigate('/');
    }

    private async isSessionAlive(): Promise<boolean> {
        try {
            const sessionUser = await authUserService.getAuthUserData();

            return Boolean(sessionUser.id);
        } catch {
            return false;
        }
    }
}

export const ForbiddenPopupContainer = inject<{}, StoreProps>(AppState.Name)(Component);
